@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';

.confirmation-modal {
  width: 1000px;
  margin: 30px 0;
}

.confirmation-modal-body {
  height: 100px;
  padding: 15px;
  font-size: 13px;
  line-height: 1.42;
  color: @product-page--modal--text-color;
}

.combine-button {
  display: flex;

  .combine {
    width: 15px;
    height: 15px;
    margin: auto 5px auto 0;
  }
}

.button-group {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;

  > button {
    margin-left: 5px;
  }
}
